<script setup lang="ts">
import { formatPercentage } from './progress-dialog';

const props = defineProps<{
    percentage?: number;
}>();
</script>

<template>
    <div class="progress">
        <div
            class="progress-bar"
            :class="(props.percentage === -1) ? ['progress-bar-striped', 'active'] : ''"
            role="progressbar"
            :aria-valuenow="formatPercentage(props.percentage)"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{minWidth: '2em', width: (props.percentage === -1) ? '100%' : `${props.percentage ?? 0}%`}"
        >
            <slot>
                {{ formatPercentage(props.percentage) }}
            </slot>
        </div>
    </div>
</template>
